/**
 * AttivitaPage - Page Shell
 * Lista attività generali
 */

import { ActivityList } from "@/features/attivita";

export default function AttivitaPage() {
  return <ActivityList />;
}
